<template>
  <div
    v-show="$router.history.current.query.lang"
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive },
    ]"
  >
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu v-if="user_info.user_name"></user-menu>
      <mobile-menu 
        @changeName="changeName"
        @changeDatabase= "changeDatabase" 
        @changeSys="changeUserSys"
        :name= "this.menuName"
        :sys ="UserInfo.sys"
        :role="UserInfo ?UserInfo.role_id :-1" 
      ></mobile-menu>
      <template slot="links">
        <!-- 首页 -->
        <sidebar-item
          :otherClickFunc ="clickMenu"
          :link="{ name: this.$I18n('index'), icon: 'dashboard', path: '/dashboard' + `?lang=${$router.history.current.query.lang}`}"
        >
        </sidebar-item>
        <sidebar-item
          v-if="showConfig"
          :otherClickFunc ="clickMenu"
          :link="{ name: '配置文件', icon: 'api', path: '/__config__' + ($router.history.current.query.lang == 'en' ?'?lang=en' :'') }"
        >
        </sidebar-item>
        <sidebar-item 
          v-for="mainItem in menuList" 
          :key="mainItem.menu_key" 
          :link="{
            name : mainItem.menu_name , 
            icon : menuInfo.main[mainItem.menu_key].icon,
            custom_icon: menuInfo.main[mainItem.menu_key].custom,
          }"
        >
          <template v-if="menuInfo.main[mainItem.menu_key].icon === 'vas'" slot="icon">
            <object style="width: 26px; margin:2px 17px 2px 2px;float: left;" type="image/svg+xml" data="/icon/vas.svg"></object>
          </template>
          <sidebar-item
            v-for= "subItem in mainItem.sub_menus"
            :otherClickFunc ="clickMenu"
            :key = "subItem.menu_key"
            :actived = "$router && $router.history.current && $router.history.current.fullPath.includes(menuInfo.sub[subItem.menu_key] + ($router.history.current.query.lang == 'en' ?'?lang=en' :'?lang=zh')) "
            :link="{
              name : subItem.menu_name,  
              path : menuInfo.sub[subItem.menu_key] + `?lang=${$router.history.current.query.lang}`,
            }"
          ></sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    
    <div class="main-panel" :style="{'background-color':'#fafafa'}">
      <top-navbar
        v-if="user_info.id"
        @changeName="changeName"
        @changeDatabase= "changeDatabase" 
        @changeSys="changeUserSys"
        :name= "this.menuName"
        :sys ="UserInfo.sys"
        :role="UserInfo ?UserInfo.role_id :-1" 
      />

      <!-- 右侧fix按钮 -->
      <!-- <fixed-plugin
        :color.sync="sidebarBackground"
        :colorBg.sync="sidebarBackgroundColor"
        :sidebarMini.sync="sidebarMini"
        :sidebarImg.sync="sidebarImg"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin> -->

      <div
        :class="{ content: !$route.meta.hideContent , 'diy-body' : $root.state.mobile }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in" v-if="user_info.user_id">
          <!-- your content here -->
          <router-view :key="$root.state.apiurl" v-if="user_sys && user_database" :userinfo_sys="user_sys" :userinfo_database="user_database"></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "/public/font/iconfont.css"
import menu from "/public/ucfg/menu.js"
// import "/public/font/iconfont.js"

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
// import FixedPlugin from "../../FixedPlugin.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    // FixedPlugin,
    MobileMenu,
    UserMenu,
    ZoomCenterTransition,
  },
  data() {
    return {
      user_sys: "",
      user_database: "",
      rotatedeg: 0,
      loadingInterval : 0,
      nowLoading :false,
      menuName : this.$I18n("index"),
      menuList : [],
      sidebarBackgroundColor: "white",
      sidebarBackground: "azure",
      sidebarBackgroundImage: "./img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      menuInfo : {
        main: {...menu.main},
        sub : {...menu.sub},
      },

      user_info: {}, // USER INFO
    };
  },
  methods: {
    getMenu(){
      return this.$api.getMenu({
        type : 1,
      })
        .then(this.$Then(res => {
          if(res.data){
            this.menuList = res.data.map(item => {
              if (this.$router.history.current.query.lang !== "en"){
                item.menu_name = item.menu_cn_name;
                if(!item.sub_menus){
                  item.sub_menus = [];
                }
                item.sub_menus = item.sub_menus.map(subItem => {
                  subItem.menu_name = subItem.menu_cn_name;
                  return subItem
                })
                return item
              } 
              return item
            })
          }
        }))
        .then(() => {
          let sub  = "";
          // 根据URL确定该URL对应的 菜单的key
          for(let subKey in this.menuInfo.sub){
            if(this.menuInfo.sub[subKey] === this.$route.fullPath.split("?")[0]){
              sub  = subKey;
            }
          }
          if (sub === ""){
            return;
          }
          //根据菜单的key确定菜单的name (国际化)
          for(let i=0; i < this.menuList.length; i++){
            for(let j=0; j< this.menuList[i].sub_menus.length; j++){
              if (this.menuList[i].sub_menus[j].menu_key === sub) {
                this.menuName = this.menuList[i].sub_menus[j].menu_name;
                return;
              }
            }
          }
        })
        .catch(this.$Catch(this.$I18n("get_error"),errorMSG => {
          if(errorMSG && errorMSG.code === 401){
            localStorage.acc_token = "";
            this.$router.push({
              path : "/login",
              query: this.$router.history.current.query,
            }).catch(() => {});
          }
        }))
    },
    changeUserSys(newSys){
      if(typeof newSys !== "string"){
        console.error("Error sys");
        return
      }
      this.user_sys = newSys;
    },
    changeDatabase(newData){
      if(typeof newData !== "string"){
        console.error("Error sys");
        return
      }
      this.user_database = newData;
    },
    changeName(name){
      this.menuName = name;
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    clickMenu (name){
      this.menuName = name;
    },
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
  },
  watch: {
    menuList(newValue){
      if(newValue && newValue.length > 0){
        newValue.forEach(i => {
          if(!this.menuInfo.main[i.menu_key]){
            this.menuInfo.main[i.menu_key] = {
              icon : "settings",
            }
          }
        })
      }
    },
    '$router.history.current.query':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    "$root.state.apiurl":{
      handler(){
        this.getMenu().then(() => {
          let urlList = [];
          if(this.menuList){
            this.menuList.forEach(main => {
              if(main.sub_menus){
                main.sub_menus.forEach(sub => {
                  urlList.push(menu.sub[sub.menu_key]);
                })
              }
            })
          }
          if(!urlList.includes(this.$router.history.current.path) && this.$router.history.current.path !== "/dashboard"){
            this.$router.push({
              path : "/dashboard",
              query: this.$router.history.current.query,
            })
          }
        })
        return 
      },
      immediate: true,
      deep: true,
    },
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
  created () {
    if (Object.keys(this.UserInfo).length === 0){
      this.$api.userInfo()
        .then(this.$Then(res => {
          this.$setUserInfo(res.data);
          this.user_info = res.data;
        }))
        .then(() => {
          switch(this.$router.history.current.fullPath){
            case "/user/info" :
              this.menuName = this.$I18n('personal_info')
              break;
            case "/user/bills" :
              this.menuName = this.$I18n('bills')
              break;
            default: 
              break;
          }
        })
        .catch(this.$Catch(this.$I18n("get_error")))
    } else {
      this.user_info = this.UserInfo;
      switch(this.$router.history.current.fullPath){
        case "/user/info" :
          this.menuName = this.$I18n('personal_info')
          break;
        case "/user/bills" :
          this.menuName = this.$I18n('bills')
          break;
        default: 
          break;
      }
    }
  },
  computed: {
    showConfig(){
      return window.location.hostname === 'localhost' && window.appConfig.__test_config
    },
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.diy-body{
  max-height: calc( 100vh - 72px);
  overflow-y: auto;
  // padding-bottom: 10px !important;
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.modal-load-icon{
  color: #00bcd4 !important;
  font-size: 100px !important;
  display: inline-block;
  line-height: 100px;
}
</style>
